import { get } from 'lodash';

export default class {
  constructor(article) {
    this.article = article;
  }

  get parentCategoryName() {
    return get(this.article, 'category.parentCategory.name');
  }

  get prod() {
    return {
      NewsAndAnalysis: 'article',
      Guides: 'article',
      Reviews: 'review',
    }[this.parentCategoryName];
  }

  get type() {
    return {
      NewsAndAnalysis: 'at',
      Guides: 'at',
      Reviews: 'rv',
    }[this.parentCategoryName];
  }

  get adUnitAttributes() {
    return {
      type: this.type,
    };
  }

  get targeting() {
    return {
      prod: this.prod,
    };
  }
}
